module.exports = __webpack_public_path__ + "img/icon-win.a90e23c0.png";